exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wgt .wgt-action-epa-buttons {\n  display: inline-flex;\n  width: 100%;\n  height: auto;\n  padding-top: 4%;\n  padding-bottom: 4%;\n  justify-content: space-between; }\n\n.wgt .wgt-action-epa-star {\n  background-color: transparent;\n  border: none;\n  width: 100%;\n  height: auto;\n  padding: 0% 2% 0% 2%; }\n", ""]);

// exports
